module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "center-ns mb4 limit-width"
  }, [_c('div', [_c('div', {
    staticClass: "responsive"
  }, [_c('div', {
    staticClass: "mt4",
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "flex-direction": "row",
      "flex-wrap": "wrap",
      "padding-left": "1rem",
      "padding-right": "1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "100%"
    }
  }, [_vm._l((_vm.selectedPhones.length), function(i) {
    return _c('div', {
      key: i,
      staticClass: "mr2 mt3 responsive-center",
      staticStyle: {
        "margin-left": "auto",
        "width": "95%",
        "max-width": "800px"
      }
    }, [_c('span', {
      staticClass: "mb2",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('h2', {
      staticClass: "f5 db mb3",
      staticStyle: {
        "margin-top": "auto",
        "margin-bottom": "auto",
        "text-decoration-line": "underline"
      }
    }, [_vm._v("Phone #" + _vm._s(i))]), _vm._v(" "), (i > 1) ? _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      },
      on: {
        "click": function($event) {
          return _vm.removePhone(i - 1, $event)
        }
      }
    }, [_c('a', {
      staticClass: "f6 fw4 ttc color-theme",
      attrs: {
        "href": ""
      }
    }, [_vm._v("Remove")])]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._m(0, true), _vm._v(" "), _c('select', {
      staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
      attrs: {
        "id": "make"
      },
      domProps: {
        "value": _vm.selectedPhones[i - 1].make
      },
      on: {
        "input": function (e) { return _vm.setPhoneMake(e, i - 1); }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select a make")]), _vm._v(" "), _vm._l((_vm.allMakes), function(make) {
      return _c('option', {
        key: make,
        domProps: {
          "value": make
        }
      }, [_vm._v(_vm._s(make))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('select', {
      staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
      attrs: {
        "id": "model"
      },
      domProps: {
        "value": _vm.selectedPhones[i - 1].model
      },
      on: {
        "input": function (e) { return _vm.setPhoneModel(e, i - 1); }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select a model")]), _vm._v(" "), _vm._l((_vm.filterModelsBySelectedMake(_vm.selectedPhones[i - 1].make)), function(model) {
      return _c('option', {
        key: model,
        domProps: {
          "value": model
        }
      }, [_vm._v(_vm._s(model) + "\n                ")])
    })], 2)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-100 mt3 mb5 mw5 f7",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('ak-button', {
    staticStyle: {
      "font-size": "1rem",
      "line-height": "1.3"
    },
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addPhone.apply(null, arguments)
      }
    }
  }, [_c('pre', {
    staticClass: "cera-round-pro"
  }, [_vm._v(_vm._s(_vm.addPhoneButtonCaption))])])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mb4 flex-ns flex-wrap justify-center",
    staticStyle: {
      "flex": "1",
      "padding-left": "1rem",
      "padding-right": "1rem"
    }
  }, [(_vm.featureFlagMonthlyBillingActive) ? _c('div', {
    staticClass: "tc mb4 pt4 lh-copy flex responsive-center",
    staticStyle: {
      "flex": "100%",
      "max-width": "800px",
      "margin-right": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "2",
      "min-width": "327px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.monthlyToggle),
      expression: "monthlyToggle"
    }],
    staticClass: "dn",
    attrs: {
      "id": "monthlyToggle1",
      "type": "radio",
      "name": "monthlyToggle"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.monthlyToggle, false)
    },
    on: {
      "change": function($event) {
        _vm.monthlyToggle = false
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pv2 tc b ba br1 br--right b--silver silver bg-white pointer",
    staticStyle: {
      "padding": ".5rem 1rem"
    },
    attrs: {
      "tabindex": "0",
      "for": "monthlyToggle1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.monthlyToggle = false
      }
    }
  }, [_vm._v("Annual")]), _vm._v(" "), _c('span', {
    staticClass: "pv2 ph3 tc b silver"
  }, [_vm._v("OR")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.monthlyToggle),
      expression: "monthlyToggle"
    }],
    staticClass: "dn",
    attrs: {
      "id": "monthlyToggle2",
      "type": "radio",
      "name": "monthlyToggle"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.monthlyToggle, true)
    },
    on: {
      "change": function($event) {
        _vm.monthlyToggle = true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pv2 tc b ba br1 br--left b--silver silver bg-white pointer",
    staticStyle: {
      "padding": ".5rem 1rem"
    },
    attrs: {
      "tabindex": "0",
      "for": "monthlyToggle2"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.monthlyToggle = true
      }
    }
  }, [_vm._v("Monthly")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "responsive-center",
    staticStyle: {
      "flex": "100%",
      "max-width": "800px",
      "margin-right": "auto"
    }
  }, [_c('ak-summary-card-wm', {
    attrs: {
      "name": _vm.coverageName,
      "price": _vm.monthlyToggle ? _vm.monthly.priceWithDiscount : _vm.annual.priceWithDiscount,
      "featured": !_vm.monthlyToggle,
      "coverageIds": _vm.monthlyToggle ? _vm.selectedMonthlyCoverageIds : _vm.selectedAnnualCoverageIds,
      "annual": !_vm.monthlyToggle,
      "savings": _vm.savings,
      "activationFee": false,
      "planType": 'PHONE',
      "phoneModels": _vm.selectedPhoneModels,
      "selectedCoverages": _vm.monthlyToggle ? _vm.selectedMonthlyCoverages : _vm.selectedAnnualCoverages,
      "conversionCaption": 'Register Now',
      "disabled": !_vm.allPhoneDataWasSelected
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('ak-coverage-currency-toggle', {
    attrs: {
      "planType": _vm.planType,
      "planInterval": _vm.planInterval
    }
  })], 1)], 1)])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "make"
    }
  }, [_vm._v("Make"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "model"
    }
  }, [_vm._v("Model"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 f7 f5-ns mw7-ns center-ns tc cera-round-pro"
  }, [_c('span', {
    staticClass: "lh-copy"
  }, [_vm._v("Plans can be cancelled at anytime for a pro-rated refund.")]), _vm._v(" "), _c('br'), _vm._v("\n      Contact "), _c('a', {
    staticClass: "color-theme lh-copy",
    attrs: {
      "href": "mailto:billing@getakko.com"
    }
  }, [_vm._v("billing@getakko.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "black f6 mb3 mw7-ns center tc lh-copy"
  }, [_vm._v("\n        Elite Risk Insurance Solutions Lic#0G40499.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7957c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/SelectMultiplePhoneCoverageBillingWm.vue
// module id = 621
// module chunks = 0